<h2 mat-dialog-title>
  {{ overlayHandler.dialog()?.titleTrxId | translate }}
</h2>
<mat-dialog-content>
  <div class="od-content-container">
    <div class="od-content-icon">
      @switch (overlayHandler.dialog()?.type) {
        @case ('error') {
          <mat-icon class="error-icon__large" [svgIcon]="'error'"></mat-icon>
        }
      }
    </div>
    {{ overlayHandler.dialog()?.messageTrxId | translate }}
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  @if (overlayHandler.dialog()?.closeable) {
    <crm-button-secondary mat-dialog-close>{{
      'general.understood' | translate
    }}</crm-button-secondary>
  }
</mat-dialog-actions>
